import { DOCUMENT } from '@angular/common';
import { Component, OnInit,HostListener  } from '@angular/core';


import { Inject } from "@angular/core";

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  profilType : string ;

  toTop : boolean = false;

  projectManagementsubMenu : boolean = false;
  recrutingSubMenu : boolean = false;

  menuItem : string;

  constructor(@Inject(DOCUMENT) private document: Document) { }

  ngOnInit(): void {
    this.menuItem = localStorage.getItem('menuItem');
    this.profilType = localStorage.getItem('profil');
  }

  ngAfterViewInit() {
    this.scrollTotop();
  }

  
@HostListener("window:scroll", [])
onWindowScroll() {
  if ( window.scrollY > 280) {
    this.toTop = true;
  }else{
    this.toTop = false;
  }
 }

  showProjectManagementSubmenu(){
    this.projectManagementsubMenu = !this.projectManagementsubMenu;
  }

  showRecruitingSubMenu(){
    this.recrutingSubMenu = !this.recrutingSubMenu;    
  }

  scrollTotop(){
    
  }
  

  menuItemFunction(menuItem : string){
    switch (menuItem) {
      case 'profil':
        this.menuItem = 'profil';
        localStorage.setItem('menuItem', menuItem);
        break;
      case 'creation':
        this.menuItem = 'creation';
        localStorage.setItem('menuItem', menuItem);
        break;
      case 'follow':
        this.menuItem = 'follow';
        localStorage.setItem('menuItem', menuItem);
        break; 
      case 'recruiting':
        this.menuItem = 'recruiting';
        localStorage.setItem('menuItem', menuItem);
        break; 
      case 'compensation':
        this.menuItem = 'compensation';
      localStorage.setItem('menuItem', menuItem);
        break;
      case 'profil':
        this.menuItem = 'profil';
      localStorage.setItem('menuItem', menuItem);
        break;
      case 'timeline':
        this.menuItem = 'timeline';
      localStorage.setItem('menuItem', menuItem);
        break;
      case 'setting':
        this.menuItem = 'setting';
        break;
      default:
        break;
    }
  }
}
